import { computed, get } from '@ember/object';

export default function computedRatio(numerator, denominator) {
  return computed(numerator, denominator, function () {
    let sum = get(this, numerator);
    let total = get(this, denominator);

    if (total > 0) {
      return sum / total;
    }

    return;
  });
}
